var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14C0 6.26762 6.26762 0 14 0C21.7324 0 28 6.26762 28 14C28 21.7315 21.7324 28 14 28C6.26762 28 0 21.7315 0 14ZM13.7773 11.0167C13.6775 9.58782 14.5569 8.28232 15.9481 7.7757C16.4609 7.59545 17.3289 7.5727 17.8976 7.7302C18.1208 7.79757 18.5425 8.02332 18.8435 8.22545L19.3886 8.5982L19.9897 8.40657C20.324 8.30595 20.7694 8.13707 20.9698 8.0242C21.1588 7.92357 21.3259 7.86757 21.3259 7.90082C21.3259 8.09157 20.9138 8.74432 20.569 9.10482C20.1009 9.61145 20.2347 9.65607 21.1806 9.31832C21.7476 9.1267 21.7599 9.1267 21.6479 9.34107C21.5805 9.45307 21.2358 9.84682 20.8683 10.2073C20.2453 10.8259 20.212 10.8933 20.212 11.4113C20.212 12.2102 19.834 13.8762 19.4551 14.7871C18.7534 16.4986 17.251 18.2661 15.7478 19.1551C13.6329 20.4037 10.8162 20.7196 8.445 19.9881C7.65575 19.7396 6.29688 19.1096 6.29688 18.9976C6.29688 18.9634 6.709 18.9188 7.21037 18.9074C8.25914 18.8856 9.28543 18.5994 10.1941 18.0753L10.7952 17.7148L10.1049 17.4786C9.12488 17.1408 8.2455 16.3638 8.02325 15.6323C7.95587 15.3952 7.97862 15.3838 8.60163 15.3838L9.24825 15.3742L8.70225 15.1152C8.0565 14.7879 7.46675 14.2376 7.17712 13.6741C6.96537 13.2681 6.6985 12.2443 6.77637 12.1656C6.79825 12.1314 7.03275 12.1988 7.29962 12.2889C8.067 12.5698 8.16762 12.5024 7.72225 12.0299C6.8875 11.1742 6.63112 9.90195 7.03188 8.69795L7.22 8.15807L7.955 8.88957C9.45825 10.3639 11.2284 11.2416 13.254 11.5006L13.8105 11.5679L13.7773 11.0167Z",
    fill: "url(#paint0_linear_5143_5404)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5143_5404",
    x1: 3.5,
    y1: 2.52778,
    x2: 26.8333,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E470AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#7230FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.02c0ee0b779abf9e3783ffff3afafcf1.svg";
export { ForwardRef as ReactComponent };